import { useQuery } from 'data-fetching-client';
import { APP_DETAILS_QUERY } from '../queries/appDetailsQuery';
export default function useDetails({
  appContext,
  slug,
  skip,
  onDetailsCompleted
}) {
  const {
    data: detailsData,
    loading: detailsLoading,
    error: detailsError
  } = useQuery(APP_DETAILS_QUERY, {
    variables: {
      slug,
      appContext
    },
    onCompleted: onDetailsCompleted,
    skip
  });
  return {
    detailsData,
    detailsLoading,
    detailsError
  };
}